import { render, staticRenderFns } from "./ProdutoNewModal.vue?vue&type=template&id=07d8a350&scoped=true"
import script from "./ProdutoNewModal.vue?vue&type=script&lang=js"
export * from "./ProdutoNewModal.vue?vue&type=script&lang=js"
import style0 from "./ProdutoNewModal.vue?vue&type=style&index=0&id=07d8a350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d8a350",
  null
  
)

export default component.exports